import { EventModel } from 'src_common/common/websocket2/models/EventModel';

export const isNflCompetition = (event: EventModel): boolean => {
    const competitionName = event.competition2.getModel()?.name;
    return competitionName === 'NFL Matches' || competitionName === 'US NFL';
};

export const buildGeniusGameTrackerUrl = (
    baseUrl: string,
    productName: string,
    fixtureId: string,
    event: EventModel
): string => {
    if (isNflCompetition(event)) {
        const params = new URLSearchParams({
            productName,
            tab: 'field',
        });

        return `${baseUrl}/multisportgametracker?group[0][fixtureId]=${encodeURIComponent(fixtureId)}&${params.toString()}`;
    }

    return `${baseUrl}/multisportgametracker?fixtureId=${encodeURIComponent(fixtureId)}&productName=${encodeURIComponent(productName)}`;
};
